<template>
  <div>
    <h3 class="account-sub-title d-none d-md-block mt-0 pt-1 ml-1">
      <i class="icon-user-2 align-middle mr-3 pr-1"></i>
      {{ translations.newAddress2 }}
    </h3>
    <div class="account-content">
      <form @submit.prevent="createShippingAddress">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="country">
                {{ translations.state }}
                <span class="required">*</span>
              </label>
              <div>
                <vue-select
                  :options="countries"
                  v-model="countryId"
                  :custom-label="customLabel"
                  @search-change="getCountries"
                  id="id"
                  :loading="isLoading"
                  @select="getTownsByCountryId"
                  :placeholder="translations.chooseState"
                >
                  <template slot="noOptions"> {{ translations.listIsEmpty }} </template>
                  <template slot="noResult">
                    {{ translations.noResultsAccordingToTheGivenParameters }} </template>
                </vue-select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="town">
                {{ translations.forms.labels.town }}
                <span class="required">*</span>
              </label>
              <div>
                <vue-select
                  :options="towns"
                  v-model="townId"
                  :custom-label="customLabel"
                  @search-change="getTowns"
                  id="id"
                  :loading="isLoading"
                  :placeholder="translations.chooseTown"
                >
                  <template slot="noOptions"> {{ translations.listIsEmpty }} </template>
                  <template slot="noResult">
                     {{ translations.noResultsAccordingToTheGivenParameters }} </template>
                </vue-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="zip-code">
                {{ translations.zipCode }}
                <span class="required">*</span>
              </label>
              <input
                v-model="zipCode"
                type="text"
                class="form-control mw-100"
                :placeholder="translations.zipCode"
                id="zip-code"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="address">
                {{ translations.forms.labels.address }}
                <span class="required">*</span>
              </label>
              <input
                v-model="address"
                type="text"
                class="form-control mw-100"
                id="address"
                :placeholder="translations.forms.labels.address"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="phone">
                {{ translations.phoneNumber }}
                <span class="required">*</span>
              </label>
              <input
                v-model="phoneNumber"
                type="text"
                class="form-control mw-100"
                :placeholder="translations.phoneNumber"
                id="phone"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  v-model="isDefault"
                  class="custom-control-input"
                  id="is-default-address"
                />
                <label class="custom-control-label" for="is-default-address">
                  {{ translations.defaultAddress2 }}?
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-footer mt-3 mb-0">
          <button type="submit" class="btn btn-primary mr-0">{{ translations.save }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-multiselect';

import api from '@/services/api';
import { translations } from '@/mixins';

export default {
  name: 'NewAddress',
  mixins: [translations],
  components: {
    VueSelect,
  },
  data() {
    return {
      townId: null,
      zipCode: '',
      address: '',
      countryId: null,
      phoneNumber: '',
      isLoading: false,
      isDefault: true,
    };
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries.map((item) => ({
        id: item.id,
        label: item.title,
      }));
    },
    towns() {
      return this.$store.getters.getTowns.map((item) => ({
        id: item.id,
        label: item.title,
        ...item,
      }));
    },
  },
  methods: {
    customLabel({ label }) {
      return label;
    },
    createShippingAddress() {
      const {
        address, zipCode, phoneNumber, countryId, townId, isDefault,
      } = this;
      api
        .createShippingAddress({
          address,
          zipCode,
          phoneNumber,
          countryId: countryId.id,
          townId: townId.id,
          isDefault,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Address' });
        });
    },
    onCountryChange({ id }) {
      this.townId = null;
      this.$store.dispatch('getTowns', {
        sortBy: 'title',
        isSortAscending: true,
        countryId: id,
      });
    },
    loadCountries({ callback, searchQuery }) {
      this.$store
        .dispatch('getCountries', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.countries);
        });
    },
    loadTowns({ callback, searchQuery }) {
      this.townId = null;

      this.$store
        .dispatch('getTowns', {
          isSortAscending: true,
          quickSearch: searchQuery,
          sortBy: 'title',
          countryId: this.countryId,
        })
        .then(() => {
          callback(null, this.towns);
        });
    },
    getCountries(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getCountries', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    getTownsByCountryId({ id }) {
      this.$store
        .dispatch('getTowns', {
          countryId: id,
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getTowns(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getTowns', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getCountries', { retrieveAll: true });
  },
};
</script>
<style lang="scss">
.vue-treeselect__control {
  max-width: 480px;
  height: 46px;
  border-radius: 0;
}

.vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
  line-height: 44px;
}

.vue-treeselect__multi-value-item {
  height: 34px;
}
</style>
